import { ReplaySubject } from 'rxjs';

import {
  SelectionEvent,
  SelectionEventInitiator,
  useGridSelectedRows
} from '@/pages/ContractLines/hooks/useGridSelectionSubscription';
import { ContractLineBillingCycleOutput, VariableContractLineOutput } from '@/graphql/contracts/_generated_/contracts';

export type ContractLineSelectionPayload = {
  contractLine: ContractLineBillingCycleOutput | VariableContractLineOutput;
};

export type RefreshPayload = {
  initiator: string;
};

export const linesSelectionObservable =
  new ReplaySubject<SelectionEvent<ContractLineSelectionPayload>>();

export function clearLinesSelection() {
  linesSelectionObservable.next({
    initiator: SelectionEventInitiator.EXTERNAL_INITIATOR,
    selectedGridRows: []
  });
}

export function useSelectedLines() {
  return useGridSelectedRows(linesSelectionObservable);
}

export const lineRefreshObservable = new ReplaySubject<RefreshPayload>();

export const triggerLineRefresh = () => {
  lineRefreshObservable.next({ initiator: 'manual' });
};
